// This file is the main entry point for the package.
// It re-exports all the necessary functions, types, and objects
// from the other modules to be consumed by external applications.

// From middleware.ts
export {
  createMiddleware,
  createPersonalizationMiddleware,
  config,
} from "./middleware";
export type { MiddlewareConfig } from "./middleware";

// From contextCollector.ts
export { collectRequestContext } from "./contextCollector";

// From segmentEvaluator.ts
export { createSegmentEvaluator } from "./segmentEvaluator";

// From types.ts
export type {
  DeviceInfo,
  UtmParams,
  GeolocationInfo,
  CustomAttributes,
  RequestContext,
  Segment,
  SegmentEvaluationResult,
  SegmentEvaluatorConfig,
} from "./types";
